import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Web3 from "web3";
import BalanceABI from "../../Web3/balanceAbi.json";
import balanceAddress from "../../Web3/balanceAddress";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import ExploreList from "./ExploreList";
import {
    Link,
    useNavigate,
    NavLink,
    useLocation,
} from "react-router-dom";
import DarkMode from "../DarkMode/DarkMode";
import "./HeaderNew.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Axios from "../../Axios";
import { useRef } from "react";
import Avatar from "@mui/material/Avatar";
import PersonIcon from "@mui/icons-material/Person";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import LogoutIcon from "@mui/icons-material/Logout";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Menu from "@mui/material/Menu";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Album2 from "../../img/dster-webp/bs4.webp";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import { useTheme, useMediaQuery } from '@mui/material';
import dwhite from '../../img/dster-webp/dwhite.webp'
import ddark from '../../img/dster-webp/d.dark.webp'
import HistoryIcon from '@mui/icons-material/History';
import MessageIcon from '@mui/icons-material/Message';
import RadioIcon from '@mui/icons-material/Radio';
import PublicIcon from '@mui/icons-material/Public';


const drawerWidth = 240;

function HeaderNew(props) {
    const [isClosing, setIsClosing] = React.useState(false);
    const [signin, setSignin] = React.useState(false);
    const [welcome, setWelcome] = React.useState(false);
    const isMount = useRef(false);
    const [btnColor1, setBtnColor1] = React.useState(true);
    const [btnColor, setBtnColor] = React.useState(false);
    const [btnColor2, setBtnColor2] = React.useState(false);
    const requestAcc = useRef(true);
    const [metaAccount, setMetaAccount] = useState("");

    const navigate = useNavigate();

    const [isActive, setIsActive] = useState(true);
    const redirectPath = "/";
    const timeoutSeconds = 15 * 60 * 1000;

    const [anchorE2, setAnchorE2] = useState(null);
    const [memo, setMemo] = useState({});
    const [UseId, setUseId] = useState('');

    const open2 = Boolean(anchorE2);
    const id2 = open2 ? "simple-popover" : undefined;

    const handleCloseMessage = () => {
        setAnchorE2(null);
    };


    useEffect(() => {
        screenInactive();
    }, [timeoutSeconds, isActive, navigate, redirectPath]);
    useEffect(() => {
        if (location.pathname === "/backstagepass") {
            setBtnColor(true);
        } else if (
            location.pathname === "/create" ||
            location.pathname === "/mintnft" ||
            location.pathname === "/upload"
        ) {
            setBtnColor2(true);
            setBtnColor(false);
        } else {
            setBtnColor(false);
            setBtnColor2(false);
        }
    }, []);

    const screenInactive = () => {
        let timeoutId;

        const resetTimeout = () => {
            clearTimeout(timeoutId);
            if (isActive) {
                timeoutId = setTimeout(() => {
                    logout();
                }, timeoutSeconds);
            }
        };

        const handleMouseActivity = () => {
            setIsActive(true);
            resetTimeout();
        };

        resetTimeout();

        document.addEventListener("mousemove", handleMouseActivity);
        document.addEventListener("keydown", handleMouseActivity);

        return () => {
            clearTimeout(timeoutId);
            document.removeEventListener("mousemove", handleMouseActivity);
            document.removeEventListener("keydown", handleMouseActivity);
        };
    };

    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    const logout = () => {
        if (localStorage.getItem("iphephile") != null) {
            navigate("/");


            localStorage.clear();
            toast.success("Logged out Successfully", {
                duration: 3000, // Set the duration for which the toast is visible
            });

        }
        else {
            navigate('/')
        }
    };

    const [uploadtrack, setUploadtrack] = React.useState(null);

    const handleUploadTrack = () => {
        setSignin(true);
        setWelcome(true);
        setUploadtrack(true);
        setTimeout(() => {
            setWelcome(false);
            setUploadtrack(false);
        }, "1500");
    };

    React.useEffect(() => {
        if (uploadtrack === false) {
            navigate("/register");
        }
    }, [uploadtrack]);
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);

    const progressRef = React.useRef(() => { });
    React.useEffect(() => {
        progressRef.current = () => {
            if (progress > 100) {
                setProgress(0);
                setBuffer(10);
            } else {
                const diff = Math.random() * 10;
                const diff2 = Math.random() * 10;
                setProgress(progress + diff);
                setBuffer(progress + diff + diff2);
            }
        };
    });

    React.useEffect(() => {
        const timer = setInterval(() => {
            progressRef.current();
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, []);

    const handleClick = (event) => {
        navigate("/profile");
    };

    const clickFileInput = useRef(null);

    const [mobileOpen, setMobileOpen] = React.useState(false);

    const [balance, setBalance] = useState(false);
    const [profileData, setProfileData] = useState({});
    const [notify, setNotify] = useState(0);
    const tokens = localStorage.getItem("iphephile");

    useEffect(() => {
        if (!isMount.current) {
            // getProfile();
            // getNotification()
            if (!metaAccount && tokens) {
                // requestAccount();
            }
            isMount.current = true;
        } else {
            // console.log("Run", location.pathname);
        }
    }, []);

    useEffect(() => {
        if (tokens) {
            getProfile();
            getNotification();
        }

    }, [props?.prf]);



    const getNotification = async () => {
        try {
            const datas = await Axios.post(
                "/notification/get_my_notification",
                { type: "count" },
                {
                    headers: {
                        Authorization: tokens,
                    },
                }
            )
                .then((res) => {
                    if (res?.data?.success) {
                        setNotify(res?.data?.result[0]?.count);
                    } else {
                        setNotify(0);
                    }
                })
                .catch((err) => {
                    setNotify(0);
                });
        } catch (error) {
            setNotify(0);
        }
    };

    const getProfile = async () => {
        try {
            await Axios.get(`/profile/getprofile`, {
                headers: {
                    Authorization: tokens,
                },
            })
                .then(async (res) => {
                    if (res?.data?.success) {
                        setProfileData(res?.data?.result);
                        // setUpdateName(res?.data?.result?.name);
                        const secObj = {
                            name: res?.data?.result?.name ? res?.data?.result?.name : res?.data?.result?.account.slice(0, 10),
                            proPic: res?.data?.result?.profilePicture,
                            role: res?.data?.result?.role.toUpperCase()
                        }
                        const stringObj = JSON.stringify(secObj);
                        await localStorage.setItem('proDet', stringObj);
                    } else {
                        // toast.error("Can't Fetch Detail");
                    }
                })
                .catch((err) => {
                    // console.log(err);
                    if (err?.response?.data?.message == "Admin Blocked You") {
                        localStorage.clear();
                        navigate('/');
                        toast.error('Admin Blocked You');
                    }
                });
        } catch (error) {
            //console.log(error);
        }
    };

    const onChangeNetwork = async (chainIds) => {
        try {
            const WEB = new Web3(window.ethereum);

            await window.ethereum.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: WEB.utils.toHex(chainIds) }],
            });
            navigateToBack();
        } catch (err) {
            // This error code indicates that the chain has not been added to MetaMask
            if (err.code === 4902) {
                var data = {
                    name: "BNB Smart Chain Mainnet",
                    chain: "BSC",
                    rpc: [
                        "https://bsc-dataseed1.bnbchain.org",
                        "https://bsc-dataseed2.bnbchain.org",
                        "https://bsc-dataseed3.bnbchain.org",
                        "https://bsc-dataseed4.bnbchain.org",
                        "https://bsc-dataseed1.defibit.io",
                        "https://bsc-dataseed2.defibit.io",
                        "https://bsc-dataseed3.defibit.io",
                        "https://bsc-dataseed4.defibit.io",
                        "https://bsc-dataseed1.ninicoin.io",
                        "https://bsc-dataseed2.ninicoin.io",
                        "https://bsc-dataseed3.ninicoin.io",
                        "https://bsc-dataseed4.ninicoin.io",
                        "https://bsc.publicnode.com",
                        "wss://bsc.publicnode.com",
                        "wss://bsc-ws-node.nariox.org",
                    ],
                    faucets: [],
                    nativeCurrency: {
                        name: "BNB Chain Native Token",
                        symbol: "BNB",
                        decimals: 18,
                    },
                    infoURL: "https://www.bnbchain.org/en",
                    shortName: "bnb",
                    chainId: 56,
                    networkId: 56,
                    slip44: 714,
                    explorers: [
                        {
                            name: "bscscan",
                            url: "https://bscscan.com",
                            standard: "EIP3091",
                        },
                    ],
                };

                const WEB = new Web3(window.ethereum);
                await window.ethereum.request({
                    method: "wallet_addEthereumChain",
                    params: [
                        {
                            chainName: data?.chain,
                            chainId: WEB.utils.toHex(chainIds),
                            nativeCurrency: data?.nativeCurrency,
                            rpcUrls: [data?.rpc[0]],
                        },
                    ],
                });
            } else if (err.code === 4001) {
                navigate(0);
            } else {
                console.log(err);
            }
        }
    };
    const requestAccount = async () => {
        if (window?.ethereum) {
            try {
                const accounts = await window.ethereum.request({
                    method: "eth_requestAccounts",
                });

                setMetaAccount(accounts[0]);

                localStorage.setItem("accounts", accounts[0]);
            } catch (error) {
                console.log(error, "Error connecting...");
            }
        }
        // else {
        //     alert('Please Add Metamask Extension in Your Browser');
        // }
    };
    // useEffect(() => {
    //     if (requestAcc.current) {

    //         if (!metaAccount && tokens) {
    //             requestAccount()
    //         }
    //     }

    //     requestAcc.current = false
    //     console.log(requestAcc.current, ' requestAcc.current ');

    // }, [])
    const navigateToBack = async () => {
        try {
            if (window.ethereum) {
                const web3Instance = new Web3(window.ethereum);
                const browserChainId = await web3Instance.eth.getChainId();

                await window.ethereum.enable();
                // setWeb3(web3Instance);

                await window.ethereum.request({
                    method: "eth_requestAccounts",
                });
                const accounts = await web3Instance.eth.getAccounts();
                if (Number(browserChainId) === 56) {
                    const contractInstance = new web3Instance.eth.Contract(
                        BalanceABI,
                        balanceAddress
                    );
                    const balances = await contractInstance.methods
                        .balanceOf(accounts[0])
                        .call();

                    var bal = Number(balances);
                    if (bal >= 0) {
                        navigate("/backstagepass");
                    } else {
                        toast.error("Insufficient Fund In Dster Token(BSC Network)");
                        setBalance(false);
                    }

                    //  return bal
                } else {
                    onChangeNetwork(56);
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handleClick2 = (event) => {
        setAnchorEl(event.currentTarget);
        setDrop(true);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setDrop(false);
    };

    const location = useLocation();

    const [drop, setDrop] = useState(false);

    const navigateto = () => {
        if (
            location.pathname.includes("showplaylist") ||
            location.pathname.includes("createplaylist") ||
            location.pathname.includes("trackpage")
        ) {
            const value = location?.state?.speed;
            if (value !== undefined) {
                navigate(`/library`, { state: { value } });
            } else {
                navigate(-1);
            }
        } else if (
            location.pathname.includes("mintnft") ||
            location.pathname.includes("upload")
        ) {
            const value = location?.state?.value;
            if (value !== undefined) {
                navigate(`/create`, { state: { value } });
            } else {
                navigate(-1);
            }
        } else if (location.pathname.includes("create")) {
            const speedvalue = location?.state?.speed;
            const testvalue = location?.state?.value;
            if (speedvalue !== undefined) {
                var value = speedvalue;
                navigate(`/library`, { state: { value } });
            } else if (testvalue !== undefined) {
                var value = testvalue + 1;
                navigate(`/library`, { state: { value } });
            } else {
                navigate(-1);
            }
        } else if (
            (location.pathname.includes("message") ||
                location.pathname.includes("mymessage")) === true
        ) {
            navigate(-1);
        } else if (
            location.pathname.includes("staking") ||
            location.pathname.includes("premiumtracks") ||
            location.pathname.includes("artist") ||
            location.pathname.includes("createexclusive") ||
            location.pathname.includes("createvirtualmeet") ||
            location.pathname.includes("polls") ||
            location.pathname.includes("survey")
        ) {
            navigate(-1);
        } else {
            navigate("/feed");
        }
    };

    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up('md'));

    const getProDetailes = async () => {

        const objData = await JSON.parse(localStorage.getItem('proDet'));
        setMemo(objData);
        setUseId(localStorage.getItem('usrId'));
    }

    useEffect(() => {
        getProDetailes();
    }, [props?.title]);

    const drawer = (
        <div>
            <List>
                <div className="headnew-logo">
                    <Link to="/feed">
                        {/* <div className="betalogo">
                            <img src={beta} />
                        </div> */}
                        <div className="header-logo">
                            <img src={localStorage.getItem("theme") === 'true' ? ddark : dwhite} alt="logo" />
                        </div>
                    </Link>

                </div>
            </List>

            <List className="discover-text-main">
                <div className="discover-new">Discover</div>
                {tokens ? < ExploreList setmob={mobileOpen} /> : <></>}
                {/* <img src={exp} alt="exp" /> */}

            </List>
            <List>
                <div className="navlink-new">
                    <NavLink
                        to="/feed"
                        className={({ isActive }) => (isActive ? "active1" : "non-active")}
                    >
                        <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_2378_5139)">
                                <path d="M17.3586 6.6751L11.9003 2.30843C10.8336 1.45843 9.16696 1.4501 8.10863 2.3001L2.65029 6.6751C1.86696 7.3001 1.39196 8.5501 1.55863 9.53343L2.60863 15.8168C2.85029 17.2251 4.15863 18.3334 5.58363 18.3334H14.417C15.8253 18.3334 17.1586 17.2001 17.4003 15.8084L18.4503 9.5251C18.6003 8.5501 18.1253 7.3001 17.3586 6.6751ZM10.6253 15.0001C10.6253 15.3418 10.342 15.6251 10.0003 15.6251C9.65863 15.6251 9.37529 15.3418 9.37529 15.0001V12.5001C9.37529 12.1584 9.65863 11.8751 10.0003 11.8751C10.342 11.8751 10.6253 12.1584 10.6253 12.5001V15.0001Z" fill="#7C8DB5" />
                            </g>
                            <defs>
                                <clipPath id="clip0_2378_5139">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        {/* <img
                            width="22"
                            height="22"
                            src="https://img.icons8.com/3d-fluency/94/home.png"
                            alt="home"
                        /> */}

                        <div className="nav-txt">Feed</div>
                    </NavLink>
                    <NavLink
                        to="/create"
                        className={({ isActive }) => (btnColor2 ? "active1" : "non-active")}
                    >

                        <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.0783 4.57596C11.0783 7.02348 9.11592 8.986 6.66667 8.986C4.21825 8.986 2.25501 7.02348 2.25501 4.57596C2.25501 2.12843 4.21825 0.166748 6.66667 0.166748C9.11592 0.166748 11.0783 2.12843 11.0783 4.57596Z" fill="#7C8DB5" fill-opacity="0.72" />
                            <path d="M6.66667 16.8334C3.05198 16.8334 0 16.2459 0 13.9792C0 11.7117 3.07115 11.145 6.66667 11.145C10.2822 11.145 13.3333 11.7325 13.3333 13.9992C13.3333 16.2667 10.2622 16.8334 6.66667 16.8334Z" fill="#7C8DB5" fill-opacity="0.72" />
                        </svg>

                        {/* <img
                            width="22"
                            height="22"
                            src="https://img.icons8.com/color/22/circled-user-female-skin-type-7--v1.png"
                            alt="circled-user-female-skin-type-7--v1"
                        /> */}

                        <div className="nav-txt">Create</div>
                    </NavLink>
                    {tokens ? <><NavLink
                        to="/explore"
                        className={({ isActive }) => (isActive ? "active1" : "non-active")}
                    >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.66602 8.89169C1.66602 4.90146 4.8663 1.66675 8.81405 1.66675C10.7098 1.66675 12.528 2.42794 13.8685 3.78288C15.209 5.13782 15.9621 6.97551 15.9621 8.89169C15.9621 12.8819 12.7618 16.1166 8.81405 16.1166C4.8663 16.1166 1.66602 12.8819 1.66602 8.89169Z" fill="#7C8DB5" fill-opacity="0.72" />
                            <path d="M15.8438 14.712L17.9727 16.4304H18.0097C18.4404 16.8658 18.4404 17.5716 18.0097 18.0069C17.579 18.4422 16.8807 18.4422 16.45 18.0069L14.6833 15.9821C14.5163 15.8139 14.4224 15.5854 14.4224 15.3471C14.4224 15.1087 14.5163 14.8802 14.6833 14.712C15.0054 14.3921 15.5217 14.3921 15.8438 14.712Z" fill="#7C8DB5" fill-opacity="0.72" />
                        </svg>

                        {/* <img
                            width="22"
                            height="22"
                            src="https://img.icons8.com/emoji/48/magnifying-glass-tilted-left-emoji.png"
                            alt="magnifying-glass-tilted-left-emoji"
                        /> */}

                        <div className="nav-txt">Explore</div>
                    </NavLink>
                        {/* <NavLink to='/trending' className={({ isActive }) => (isActive ? 'active1' : 'non-active')} >
                        <img width="22" height="22" src="https://img.icons8.com/dusk/22/music-heart--v1.png" alt="music-heart--v1" />


                        <div className='nav-txt'>Trending</div>
                    </NavLink> */}
                        <NavLink
                            to="/library"
                            className={({ isActive }) => (isActive ? "active1" : "non-active")}
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="white-svg" d="M16.0083 12.5084C15.1 12.45 14.1667 12.7833 13.475 13.475C12.175 14.775 12.175 16.8834 13.475 18.1917C13.9167 18.6334 14.4583 18.925 15.0333 19.0667C15.35 19.15 15.6833 19.175 16.0167 19.1583C16.8083 19.125 17.5833 18.8084 18.1917 18.2C19.05 17.3417 19.3417 16.1333 19.0667 15.0417C18.9333 14.4667 18.6333 13.925 18.1917 13.4833C17.5917 12.875 16.8083 12.55 16.0083 12.5084ZM17.7 15.8167C17.7 15.9917 17.6333 16.1417 17.5167 16.2584C17.4 16.375 17.25 16.4417 17.075 16.4417H16.4583V17.0917C16.4583 17.2667 16.3917 17.4167 16.275 17.5333C16.1583 17.65 16.0083 17.7167 15.8333 17.7167C15.4917 17.7167 15.2083 17.4334 15.2083 17.0917V16.4417H14.5833C14.2417 16.4417 13.9583 16.1583 13.9583 15.8167C13.9583 15.475 14.2417 15.1917 14.5833 15.1917H15.2083V14.6C15.2083 14.2584 15.4917 13.975 15.8333 13.975C16.175 13.975 16.4583 14.2584 16.4583 14.6V15.1917H17.075C17.425 15.1917 17.7 15.475 17.7 15.8167Z" fill="#7C8DB5" fill-opacity="0.72" />
                                <path d="M13.6166 18.3083C13.3666 18.0916 13.15 17.8333 12.9833 17.55C12.675 17.05 12.5 16.4583 12.5 15.8333C12.5 13.9917 13.9916 12.5 15.8333 12.5C16.8166 12.5 17.7083 12.925 18.3083 13.6083C18.3166 13.6167 18.3166 13.625 18.325 13.625C18.325 13.575 18.3333 13.5333 18.3333 13.4917V6.50833C18.3333 3.475 16.525 1.66667 13.4916 1.66667H6.50829C6.27496 1.66667 6.04996 1.67499 5.83329 1.70832C3.20829 1.94999 1.66663 3.70833 1.66663 6.50833V13.4917C1.66663 16.2917 3.20829 18.05 5.83329 18.2917C6.04996 18.325 6.27496 18.3333 6.50829 18.3333H13.4916C13.5416 18.3333 13.5833 18.325 13.6333 18.325C13.6333 18.3167 13.625 18.3166 13.6166 18.3083Z" fill="#7C8DB5" fill-opacity="0.72" />
                                <path className="white-svg" d="M11.4834 4.41667C11.2167 4.20833 10.7334 4.00834 9.9667 4.21667L7.48336 4.90001C6.74169 5.09168 6.25835 5.71667 6.25835 6.5V9.75836C6.06669 9.6917 5.85836 9.64168 5.6417 9.64168C4.60836 9.64168 3.77502 10.4833 3.77502 11.5083C3.77502 12.5333 4.6167 13.375 5.6417 13.375C6.65836 13.375 7.49169 12.55 7.50835 11.5417C7.50835 11.5333 7.5167 11.525 7.5167 11.5167V8.43334L10.825 7.53332V8.93332C10.6334 8.86665 10.425 8.81669 10.2 8.81669C9.1667 8.81669 8.33336 9.65835 8.33336 10.6833C8.33336 11.7167 9.17503 12.55 10.2 12.55C11.2167 12.55 12.05 11.725 12.0667 10.7083C12.0667 10.7 12.075 10.6917 12.075 10.675V5.81666C12.0667 5.18333 11.8667 4.70833 11.4834 4.41667ZM5.63335 12.125C5.29169 12.125 5.0167 11.85 5.0167 11.5083C5.0167 11.1667 5.29169 10.8917 5.63335 10.8917C5.97502 10.8917 6.25003 11.1667 6.25003 11.5083C6.25003 11.85 5.97502 12.125 5.63335 12.125ZM10.1917 11.2917C9.85002 11.2917 9.57503 11.0167 9.57503 10.675C9.57503 10.3333 9.85002 10.0583 10.1917 10.0583C10.5334 10.0583 10.8084 10.3333 10.8084 10.675C10.8084 11.0167 10.5334 11.2917 10.1917 11.2917Z" fill="white" />
                            </svg>

                            {/* <img
                                width="22"
                                height="22"
                                src="https://img.icons8.com/fluency/22/photos-folder--v1.png"
                                alt="photos-folder--v1"
                            /> */}
                            <div className="nav-txt">Library</div>
                        </NavLink>

                        <NavLink
                            to="/history"
                            className={({ isActive }) => (isActive ? "active1" : "non-active")}
                        >

                            {/* <img
                                width="22"
                                height="22"
                                src="https://img.icons8.com/fluency/48/time-machine.png"
                                alt="time-machine"
                            /> */}

                            <HistoryIcon style={{ fill: '#7C8DB5B8', fontSize: '21px' }} />

                            <div className="nav-txt">History</div>
                        </NavLink>


                        {/* <NavLink
                            className={({ isActive }) => (isActive ? "active1" : "non-active")}
                            to=""
                        >
                            <img
                                width="22"
                                height="22"
                                src="https://img.icons8.com/color/22/compass--v1.png"
                                alt="compass--v1"
                            />

                            <div className="nav-txt">Explore</div>
                        </NavLink> */}
                        <NavLink
                            to="/mymessage"
                            className={({ isActive }) => (isActive ? "active1" : "non-active")}
                        >
                            <MessageIcon style={{ fill: '#7C8DB5B8', fontSize: '21px' }} />
                            {/* <img
                                width="22"
                                height="22"
                                src="https://img.icons8.com/bubbles/22/speech-bubble-with-dots.png"
                                alt="speech-bubble-with-dots"
                            /> */}

                            <div className="nav-txt">Message</div>
                        </NavLink>
                    </> : <></>}
                </div>
            </List>
            <List className="gen-dis">
                <div className="discover-new">General</div>
            </List>
            <List className="gen-dis">
                <div className="navlink-new">
                    {/* <NavLink to='/feed' className={({ isActive }) => (isActive ? 'active1' : 'non-active')} >
                        <img width="22" height="22" src="https://img.icons8.com/dusk/22/pot-player.png" alt="pot-player" />
                        <div className='nav-txt'>Player</div>
                    </NavLink> */}
                    {tokens ? <>
                        <NavLink
                            // onClick={() => {
                            //     navigateToBack();
                            // }}

                            to="/supportpage"

                            className={({ isActive }) =>
                                btnColor === true ? "active" : "non-active"
                            }
                        >

                            <RadioIcon style={{ fill: '#7C8DB5B8', fontSize: '21px' }} />

                            {/* <img
                                width="24"
                                height="24"
                                src="https://img.icons8.com/color/22/radio.png"
                                alt="radio"
                            /> */}
                            <div className="nav-txt">Backstage pass</div>
                        </NavLink>

                        <NavLink
                            to="/staking"
                            className={({ isActive }) => (isActive ? "active1" : "non-active")}
                        >

                            <PublicIcon style={{ fill: '#7C8DB5B8', fontSize: '21px' }} />

                            {/* <img
                                width="22"
                                height="22"
                                src="https://img.icons8.com/color/22/america.png"
                                alt="america"
                            /> */}
                            <div className="nav-txt">Staking</div>
                        </NavLink>
                    </>
                        : <></>}
                    {/* <NavLink
                        to="/faq"
                        className={({ isActive }) => (isActive ? "active1" : "non-active")}
                    >
                        <img
                            width="22"
                            height="22"
                            src="https://img.icons8.com/office/22/ask-question.png"
                            alt="ask-question"
                        />
                        <div className="nav-txt">FAQ</div>
                    </NavLink> */}

                </div>
            </List>
            <List>
                <div className="discover-new">BUY</div>
            </List>
            <List>
                <div className="navlink-new">
                    <NavLink
                        to="https://dreamster.exchange/"
                        target="_blank"
                        className="non-active"
                    >
                        {/* <img
                            width="22"
                            height="22"
                            src="https://img.icons8.com/fluency/22/buy.png"
                            alt="buy"
                        /> */}

                        <svg width="24" height="26" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.66683 0.173329C6.67794 0.584996 4.77794 2.03666 3.90016 3.81333L3.43349 4.745L2.45572 4.78833C1.62238 4.82083 1.40016 4.875 1.02238 5.11333C0.777939 5.27583 0.466828 5.59 0.322383 5.8175L0.0557167 6.22916L0.0223833 13.9208C0.000161112 19.0233 0.0334944 21.7858 0.111272 22.1542C0.400161 23.4975 1.40016 24.83 2.55572 25.4042C3.74461 25.9892 3.87794 26 10.6335 26C14.8335 26 17.0668 25.9567 17.4668 25.8808C18.3335 25.6967 19.2446 25.2092 19.8779 24.5917C20.9113 23.5842 21.3335 22.425 21.3335 20.6158C21.3335 19.6517 21.3557 19.5 21.5113 19.5C22.3891 19.5 23.6224 18.5358 23.8779 17.6583C23.9668 17.3117 24.0002 16.4125 23.9779 14.56L23.9446 11.9492L23.6224 11.5483C23.2335 11.0392 22.7446 10.8333 21.9557 10.8333H21.3557L21.3113 9.28416C21.2779 7.865 21.2557 7.69166 20.9668 7.09583C20.3557 5.8175 19.0668 4.91833 17.6557 4.79916L17.0002 4.73416L16.5446 3.81333C15.1668 1.04 11.8557 -0.498338 8.66683 0.173329ZM12.2335 1.21333C13.2557 1.58166 13.9113 1.9825 14.6113 2.65416C15.9335 3.94333 16.6224 5.86083 16.4002 7.62666L16.3224 8.23333H15.8891H15.4557L15.5224 7.33416C15.7002 4.79916 14.0335 2.54583 11.5002 1.89583C8.04461 1.01833 4.66683 3.81333 4.92238 7.33416L4.98905 8.23333H4.56683C4.15572 8.23333 4.13349 8.21166 4.06683 7.82166C3.87794 6.67333 4.07794 5.47083 4.66683 4.26833C5.50016 2.57833 7.10016 1.38666 9.05572 0.964163C9.83349 0.801663 11.4224 0.931663 12.2335 1.21333ZM12.0446 3.01166C13.0557 3.46666 13.7002 4.095 14.2002 5.07C14.5779 5.83916 14.6113 5.95833 14.6113 6.86833C14.6113 8.27666 14.6446 8.23333 13.4446 8.23333H12.4446V7.93C12.4446 7.7675 12.3446 7.475 12.2224 7.28C12.0002 6.93333 12.0002 6.93333 12.2224 6.57583C12.6446 5.90416 12.3891 4.9725 11.6668 4.57166C11.4446 4.44166 11.3335 4.29 11.3113 4.0625C11.2891 3.79166 11.2224 3.72666 10.9668 3.705C10.7002 3.6725 10.6335 3.72666 10.5224 3.9975C10.4557 4.18166 10.3224 4.33333 10.2224 4.33333C10.1224 4.33333 9.98905 4.18166 9.92238 3.9975C9.81127 3.72666 9.74461 3.6725 9.47794 3.705C9.23349 3.72666 9.15572 3.8025 9.13349 4.03C9.10016 4.29 9.04461 4.3225 8.64461 4.355C7.84461 4.40916 7.75572 5.1025 8.54461 5.17833L8.88905 5.21083V6.7275V8.23333H7.44461C5.73349 8.23333 5.83349 8.30916 5.83349 6.87916C5.83349 6.0125 5.87794 5.82833 6.18905 5.17833C6.63349 4.2575 7.26683 3.58583 8.10016 3.16333C8.96683 2.70833 9.45572 2.6 10.4668 2.64333C11.1446 2.67583 11.4891 2.7625 12.0446 3.01166ZM11.3335 5.41666C11.4557 5.53583 11.5557 5.73083 11.5557 5.85C11.5557 6.2725 11.1668 6.5 10.4446 6.5H9.77794V5.85V5.2H10.4446C10.9668 5.2 11.1557 5.24333 11.3335 5.41666ZM3.16683 6.93333V8.23333H2.52238C1.76683 8.23333 1.34461 8.03833 1.05572 7.56166C0.68905 6.955 1.04461 6.0125 1.72238 5.74166C1.84461 5.6875 2.22238 5.64416 2.55572 5.64416L3.16683 5.63333V6.93333ZM18.3335 5.80666C18.7668 5.93666 19.0668 6.12083 19.4891 6.5325C20.2224 7.2475 20.4446 7.88666 20.4446 9.23V10.1942L19.9113 9.67416C19.3224 9.1 18.2779 8.50416 17.6668 8.39583L17.2779 8.33083V6.97666C17.2779 5.43833 17.2335 5.4925 18.3335 5.80666ZM11.3335 7.58333C11.4557 7.7025 11.5557 7.8975 11.5557 8.01666C11.5557 8.21166 11.4779 8.23333 10.6668 8.23333H9.77794V7.8V7.36666H10.4446C10.9668 7.36666 11.1557 7.41 11.3335 7.58333ZM9.44461 9.1L17.3891 9.15416L18.0668 9.4575C19.3779 10.0533 20.3002 11.3425 20.4224 12.74L20.4779 13.4333H18.7002C16.4335 13.4333 15.9779 13.5525 15.1557 14.3433C13.9002 15.5783 13.9002 17.355 15.1557 18.59C15.9779 19.3808 16.4335 19.5 18.7002 19.5H20.4668L20.4224 20.8217C20.3891 22.0025 20.3446 22.23 20.0779 22.8042C19.6779 23.6492 18.9224 24.3858 18.0668 24.7758L17.3891 25.0792H10.6668H3.94461L3.27794 24.7758C2.41127 24.375 1.65572 23.6492 1.25572 22.815C0.977939 22.2083 0.944606 22.0242 0.911272 20.605L0.866828 19.0667H2.87794H4.88905V20.02C4.88905 20.6158 4.93349 21.0167 5.02238 21.1033C5.11127 21.19 5.73349 21.2333 7.07794 21.2333C8.68905 21.2333 9.00016 21.255 9.00016 21.3958C9.00016 21.4825 9.18905 21.7425 9.42238 21.9808C10.1224 22.7067 11.1224 22.7175 11.8779 22.0133C12.6335 21.3092 12.6335 20.2908 11.8779 19.5867C11.4113 19.1533 10.9002 19.0017 10.2779 19.11C9.81127 19.1967 9.13349 19.7383 9.04461 20.1067C8.97794 20.3667 8.96683 20.3667 7.37794 20.3667H5.77794V19.4133C5.77794 18.8175 5.73349 18.4167 5.64461 18.33C5.54461 18.2325 4.84461 18.2 3.20016 18.2H0.88905V17.7667V17.3333H4.94461C8.42238 17.3333 9.00016 17.355 9.00016 17.4958C9.00016 17.5825 9.18905 17.8425 9.42238 18.0808C10.1224 18.8067 11.1224 18.8175 11.8779 18.1133C12.6335 17.4092 12.6335 16.3908 11.8779 15.6867C11.4113 15.2533 10.9002 15.1017 10.2779 15.21C9.81127 15.2967 9.13349 15.8383 9.04461 16.2067L8.97794 16.4667H4.93349H0.88905V16.0333V15.6H3.20016C4.84461 15.6 5.54461 15.5675 5.64461 15.47C5.73349 15.3833 5.77794 14.9392 5.77794 14.17V13H7.38905C8.72238 13 9.00016 13.0217 9.00016 13.1625C9.00016 13.2492 9.18905 13.5092 9.42238 13.7475C10.1224 14.4733 11.1224 14.4842 11.8779 13.78C12.6335 13.0758 12.6335 12.0575 11.8779 11.3533C11.4113 10.92 10.9002 10.7683 10.2779 10.8767C9.81127 10.9633 9.13349 11.505 9.04461 11.8733L8.97794 12.1333H7.06683C5.73349 12.1333 5.11127 12.1767 5.02238 12.2633C4.93349 12.35 4.88905 12.7942 4.88905 13.5633V14.7333H2.88905H0.88905V11.7V8.66666L1.18905 8.85083C1.46683 9.035 2.06683 9.04583 9.44461 9.1ZM11.2779 11.9708C11.4557 12.1333 11.5557 12.3608 11.5557 12.5667C11.5557 12.7725 11.4557 13 11.2779 13.1625C11.1113 13.3358 10.8779 13.4333 10.6668 13.4333C10.4557 13.4333 10.2224 13.3358 10.0557 13.1625C9.87794 13 9.77794 12.7725 9.77794 12.5667C9.77794 12.3608 9.87794 12.1333 10.0557 11.9708C10.2224 11.7975 10.4557 11.7 10.6668 11.7C10.8779 11.7 11.1113 11.7975 11.2779 11.9708ZM22.8335 11.9708C23.0113 12.1333 23.1113 12.3608 23.1113 12.5667C23.1113 13.1192 22.6891 13.4333 21.9446 13.4333H21.3335V12.5667V11.7H21.9446C22.4557 11.7 22.6113 11.7433 22.8335 11.9708ZM23.0557 17.3117C22.9668 17.7883 22.4002 18.3842 21.9113 18.5358C21.6446 18.6117 20.6002 18.6333 19.0446 18.6117C16.6002 18.5792 16.5891 18.5792 16.1446 18.2867C15.4557 17.8425 15.1668 17.3117 15.1668 16.4667C15.1668 15.6217 15.4557 15.0908 16.1446 14.6467L16.5891 14.3542L19.7335 14.3C21.4557 14.2675 22.9113 14.2025 22.9668 14.1592C23.0668 14.0508 23.1557 16.7917 23.0557 17.3117ZM11.2779 16.3042C11.4557 16.4667 11.5557 16.6942 11.5557 16.9C11.5557 17.1058 11.4557 17.3333 11.2779 17.4958C11.1113 17.6692 10.8779 17.7667 10.6668 17.7667C10.4557 17.7667 10.2224 17.6692 10.0557 17.4958C9.87794 17.3333 9.77794 17.1058 9.77794 16.9C9.77794 16.6942 9.87794 16.4667 10.0557 16.3042C10.2224 16.1308 10.4557 16.0333 10.6668 16.0333C10.8779 16.0333 11.1113 16.1308 11.2779 16.3042ZM11.2779 20.2042C11.8335 20.735 11.4446 21.6667 10.6668 21.6667C10.2113 21.6667 9.77794 21.2442 9.77794 20.8C9.77794 20.3558 10.2113 19.9333 10.6668 19.9333C10.8779 19.9333 11.1113 20.0308 11.2779 20.2042Z" fill="#7C8DB5" fill-opacity="0.8" />
                            <path d="M16.5783 15.1643C15.5338 15.7818 15.5338 17.1468 16.5783 17.7643C17.5449 18.3384 18.8894 17.5801 18.8894 16.4643C18.8894 15.6951 18.1227 14.9476 17.3338 14.9476C17.1227 14.9476 16.7783 15.0451 16.5783 15.1643ZM17.7783 16.0309C17.9005 16.1501 18.0005 16.3451 18.0005 16.4643C18.0005 16.5834 17.9005 16.7784 17.7783 16.8976C17.656 17.0168 17.456 17.1143 17.3338 17.1143C17.2116 17.1143 17.0116 17.0168 16.8894 16.8976C16.7671 16.7784 16.6671 16.5834 16.6671 16.4643C16.6671 16.3451 16.7671 16.1501 16.8894 16.0309C17.0116 15.9118 17.2116 15.8143 17.3338 15.8143C17.456 15.8143 17.656 15.9118 17.7783 16.0309Z" fill="#7C8DB5" />
                        </svg>




                        <div className="nav-txt">Buy Crypto</div>
                    </NavLink>
                    <NavLink
                        to="https://dreamster.market/"
                        target="_blank"
                        className="non-active"
                    >
                        <img
                            width="22"
                            height="22"
                            src="https://img.icons8.com/3d-fluency/22/shopping-cart-loaded.png"
                            alt="shopping-cart-loaded"
                        />

                        <div className="nav-txt">Buy Nft</div>
                    </NavLink>
                </div>
            </List>
        </div>
    );

    return (
        <div className="header-new">
            <Box sx={{ display: "flex" }}>
                <CssBaseline />
                {/* <ToastContainer
          
        autoClose={3000}
          position="top-right"
           
        /> */}

                <Box
                    component="nav"
                    sx={{
                        "@media (min-width:991.68px)": {
                            width: drawerWidth,
                        },

                        flexShrink: { sm: 0 },
                    }}
                    aria-label="mailbox folders"
                    className="sidebar"
                >
                    <AppBar
                        position="fixed"
                        sx={{
                            "@media (min-width:991.68px)": {
                                width: `calc(100% - ${drawerWidth}px)`,
                            },

                            ml: { md: `${drawerWidth}px` },
                        }}
                        className="bg-appbar2"
                    >
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                sx={{
                                    mr: 2,

                                    "@media (min-width:991.68px)": {
                                        display: "none",
                                    },
                                }}
                            >
                                <MenuIcon className="svg-icon" />
                            </IconButton>

                            <Grid
                                container
                                spacing={0}
                                sx={{ alignItems: "center", padding: "15px 0px" }}
                            >
                                <Grid xs={8} sm={6} md={6} lg={2} xl={2}>
                                    <div className="head-title-new">
                                        {props?.title == 'feed' ? null :

                                            <ArrowBackIcon
                                                onClick={() => {
                                                    navigateto();
                                                }}
                                            />
                                        }
                                        <div className="exp-new">{props?.title}</div>

                                        {/* <ArrowBackIosNewIcon className='g-icon' /> */}
                                        {/* <div className='sp'> just for You</div> */}
                                    </div>
                                </Grid>
                                <Grid xs={0} sm={0} md={0} lg={7} xl={7}>
                                    <Box
                                        sx={{ flexGrow: 1, display: { xs: "none", lg: "flex" } }}
                                        id="header-middle-text2"
                                    >
                                        <NavLink
                                            to="/feed"
                                            className={({ isActive }) => (isActive ? "active" : "")}
                                        >
                                            Player
                                        </NavLink>

                                        <NavLink
                                            // onClick={() => {
                                            //     navigateToBack();
                                            // }}
                                            to='/supportpage'
                                            className={({ isActive }) =>
                                                btnColor === true ? "active" : ""
                                            }
                                        >
                                            Backstage pass
                                        </NavLink>

                                        <NavLink
                                            to="/staking"
                                            className={({ isActive }) => (isActive ? "active" : "")}
                                        >
                                            Staking
                                        </NavLink>


                                        <NavLink
                                            to="/create"
                                            className={({ isActive }) => (btnColor2 ? "active" : "")}
                                        >
                                            Creators
                                        </NavLink>
                                        {/* <NavLink
                                            to="/faq"
                                            className={({ isActive }) => (isActive ? "active" : "")}
                                        >
                                            FAQ
                                        </NavLink> */}


                                    </Box>
                                </Grid>
                                <Grid
                                    xs={4}
                                    sm={6}
                                    md={6}
                                    lg={3}
                                    xl={3}
                                    sx={{ textAlign: "right" }}
                                >

                                    <div className="new-head-profile">
                                        <div className="notification-svg">
                                            {tokens ? <Badge badgeContent={notify} color="primary">
                                                <NotificationsIcon
                                                    onClick={() => {
                                                        navigate("/notify");
                                                    }}
                                                />
                                            </Badge> : <></>}
                                        </div>
                                        <DarkMode />


                                        <div className="new-head-profile">
                                            {/* <div className="new-dp">
                                                <img
                                                    src={
                                                        profileData.profilePicture
                                                            ? profileData.profilePicture
                                                            : Album2
                                                    }
                                                    alt="dp"
                                                />
                                            </div>
                                            <div className="profile-name-new">
                                                {profileData?.name}
                                                <div className="new-oremium">
                                                    {profileData?.role == "artist" ? (
                                                        "ARTIST"
                                                    ) : (
                                                        <>
                                                            {profileData?.role == "user"
                                                                ? "FAN"
                                                                : "RECORD LABEL"}
                                                        </>
                                                    )}
                                                </div>
                                            </div> */}
                                            {tokens && metaAccount ?

                                                <div className="avatar-cont2" sx={{ marginTop: '0ppx' }}>
                                                    <div className="profile-img-inner" style={{ cursor: "pointer" }}


                                                    >
                                                        <div onClick={handleClick2} className='new-head-profile'>
                                                            <div className='new-dp'>
                                                                <img src={memo?.proPic ? memo?.proPic : profileData.profilePicture && !profileData?.profilePicture?.includes("localhost") ? profileData.profilePicture : Album2} alt='dp' />
                                                            </div>
                                                            <div className='profile-name-new'>
                                                                {memo?.name ? memo?.name : profileData?.name != '' ? profileData?.name : `${profileData?.account?.slice(0, 10)}...`}
                                                                <div className='new-oremium'>
                                                                    {memo?.role ? memo?.role : profileData?.role == 'artist' ? "ARTIST" : <>{profileData?.role == 'user' ? "FAN" : ""}</>}
                                                                </div>
                                                            </div>
                                                            {drop ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                        </div>

                                                    </div>

                                                </div>


                                                : tokens && !metaAccount ?

                                                    <div className="display-flex">
                                                        <div onClick={handleClick2} className='new-head-profile'>
                                                            <div className='new-dp'>
                                                                <img src={memo?.proPic ? memo?.proPic : profileData.profilePicture && !profileData?.profilePicture?.includes("localhost") ? profileData.profilePicture : Album2} alt='dp' />
                                                            </div>
                                                            <div className='profile-name-new'>
                                                                {memo?.name ? memo?.name : profileData?.name != '' ? profileData?.name : `${profileData?.account?.slice(0, 10)}...`}
                                                                <div className='new-oremium'>
                                                                    {memo?.role ? memo?.role : profileData?.role == 'artist' ? "ARTIST" : <>{profileData?.role == 'user' ? "FAN" : ""}</>}
                                                                </div>
                                                            </div>
                                                            {drop ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                        </div>
                                                        {isLgUp && <div >
                                                            <Link className={btnColor1 ? 'active' : null} onClick={() => { requestAccount() }} >
                                                                <img
                                                                    width="30"
                                                                    height="30"
                                                                    src="https://img.icons8.com/color/30/metamask-logo.png"
                                                                    alt="metamask-logo"
                                                                />
                                                            </Link>
                                                        </div>}
                                                    </div>

                                                    : !tokens ?

                                                        <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' } }}>
                                                            <div className="login-btn">
                                                                <Link to="/login" className={btnColor1 ? 'active' : null}  >Login</Link>
                                                                <Link to="/register" className={btnColor2 ? 'active' : null} >Sign up</Link>
                                                            </div>

                                                            <div className="avatar-cont2" sx={{ marginTop: '0ppx' }}>
                                                                <div className="profile-img-inner" style={{ cursor: "pointer" }} >

                                                                </div>

                                                            </div>
                                                        </Box> : ""}

                                            {/* {drop ? (
                                            <KeyboardArrowUpIcon />
                                        ) : (
                                            <KeyboardArrowDownIcon />
                                        )} */}
                                        </div>
                                    </div>

                                    <Menu
                                        id="basic-menu"
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        MenuListProps={{
                                            "aria-labelledby": "basic-button",
                                        }}
                                        className="profile-pop-compo"
                                    >
                                        <div className="profile-popup">
                                            <div
                                                className="profile-img-inner inner-dp"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    navigate(`/artistpage/${profileData?._id ? profileData?._id : UseId}`);
                                                }}
                                            >
                                                <Avatar
                                                    alt="Remy Sharp"
                                                    src={
                                                        memo?.proPic ? memo?.proPic : profileData.profilePicture && !profileData?.profilePicture?.includes("localhost")
                                                            ? profileData.profilePicture
                                                            : Album2
                                                    }
                                                    sx={{ width: 56, height: 56 }}
                                                />
                                            </div>
                                            <div className="popup-content-profile">
                                                {tokens ? <div
                                                    onClick={() => {
                                                        navigate(`/artistpage/${profileData?._id ? profileData?._id : UseId}`);
                                                    }}
                                                >
                                                    <PersonIcon /> Profile
                                                </div> : <></>}
                                                <div
                                                    onClick={() => {
                                                        handleClose();
                                                        // navigate("");
                                                    }}
                                                >
                                                    <CurrencyExchangeIcon />
                                                    <NavLink to='https://tokenpresale.dreamster.io' target="_blank" >Buy Dreamster</NavLink>
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        navigate("/staking");
                                                    }}
                                                >
                                                    <AlternateEmailIcon /> Staking
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        navigate("/activity");
                                                    }}
                                                >
                                                    <LocalActivityIcon /> Activity
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        logout();
                                                    }}
                                                >
                                                    <LogoutIcon /> Logout
                                                </div>
                                            </div>
                                        </div>
                                    </Menu>
                                </Grid>
                            </Grid>
                        </Toolbar>
                    </AppBar>

                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Drawer
                        // container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                        sx={{
                            "@media (max-width:991.68px)": {
                                display: "block",
                            },

                            "& .MuiDrawer-paper": {
                                boxSizing: "border-box",
                                width: drawerWidth,
                            },
                        }}
                        className="sidebar"
                    >
                        {drawer}
                    </Drawer>
                    <Drawer
                        variant="permanent"
                        className="responsive-drawer"
                        sx={{
                            "@media (min-width:991.68px)": {
                                display: "block",
                            },

                            "& .MuiDrawer-paper": {
                                boxSizing: "border-box",
                                width: drawerWidth,
                            },
                        }}
                        open
                    >
                        {drawer}
                    </Drawer>
                </Box>
            </Box>
        </div >
    );
}

export default HeaderNew;